import React from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/styles";

const BackButton = styled(IconButton)(({ theme }) => ({
  color: "black",
  fontSize: "20px",
}));

const ButtonStyled = styled(IconButton)(({ theme }) => ({
  color: "black",
  fontSize: "20px",
}));

const DetailHeader = ({ title, onBack, onEdit, onDelete, onCancel }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ width: "16%" }}>
        <BackButton onClick={onBack}>
          <ArrowBackIosNewIcon />
        </BackButton>
      </div>

      <div
        style={{
          width: "68%",
          display: "flex",
          justifyContent: isSm ? "center" : "flex-start",
        }}
      >
        <Typography variant="h5">{title}</Typography>
      </div>

      <div
        style={{
          width: "16%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {onEdit && (
          <Tooltip title={"แก้ไขรายการ"}>
            <ButtonStyled onClick={onEdit}>
              <EditRoundedIcon />
            </ButtonStyled>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title={"ลบรายการ"}>
            <ButtonStyled onClick={onDelete}>
              <DeleteForeverIcon />
            </ButtonStyled>
          </Tooltip>
        )}
        {onCancel && (
          <Tooltip title={"ยกเลิกรายการ"}>
            <ButtonStyled onClick={onCancel}>
              <CancelIcon />
            </ButtonStyled>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default DetailHeader;
